import React, { useCallback } from 'react';

import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import { getAgentHubPortalSpoofingLink } from '~/services/AgentHub/AgentService';

import PortalSpoofButton from './PortalSpoofButton';

interface Props {
  user: App.User;
  buttonSx?: SxProps<Theme>;
}

function AgentHubPortalSpoofButton({ user, buttonSx }: Props) {
  const generateSpoofingLink = useCallback(
    () => getAgentHubPortalSpoofingLink({ customerId: user.id_member }),
    [user.id_member],
  );

  return (
    <PortalSpoofButton
      buttonLabel="Agent portal spoofing link"
      dialogTitle={
        <>
          Agent portal spoofing link for{' '}
          <Typography component="span" variant="inherit" fontStyle="italic">
            {user.email}
          </Typography>
        </>
      }
      generateSpoofingLink={generateSpoofingLink}
      buttonSx={buttonSx}
    />
  );
}

export default AgentHubPortalSpoofButton;
